<template>
    <div>
        <v-card raised>
            <v-card-title>
                Expire Permit
                <v-spacer></v-spacer>
                <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details></v-text-field>
            </v-card-title>
            <v-card-text>
                <v-data-table :loading="loadingExpirePermit" :headers="headers" :items="expiredPermits" :search="search" class="elevation-1">
                    <template v-slot:item.action="{ item }">
                        <v-btn color="error" :loading="item.isLoading" @click="expirePermit(item)"><v-icon small class="mr-2">update</v-icon>Expire Permit</v-btn>
                    </template>
                </v-data-table>
            </v-card-text>
        </v-card>
        <v-snackbar v-model="snack" :timeout="3000" :color="snackColor">
            {{ snackText }}
            <v-btn text @click="snack = false">Close</v-btn>
        </v-snackbar>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                search: '',
                appURL: process.env.MIX_APP_URL,
                loadingExpirePermit: false,
                expiredPermits: [],
                editedIndex: -1,
                dialog: false,
                snack: false,
                snackColor: '',
                snackText: '',
                headers: [
                    { text: 'UIN', align: 'left', sortable: true, value: 'uin',},
                    { text: 'Permit Number', align: 'left', sortable: true, value: 'permit_number',},
                    { text: 'Permit Series Code', value: 'permit_number_series_code' },
                    { text: 'Actions', value: 'action', sortable: false },
                ],
            }
        },
        created() {
            this.fetchExpirePermits();
        },
        methods: {
            fetchExpirePermits: function () {
                this.loadingExpirePermit = true;
                axios.get(this.appURL + '/api/expirepermits')
                    .then((response) => {
                        if(response.status === 200)
                        {
                            var data = response.data;
                            var addLoading = data.map(function(permit) {
                                var loading = Object.assign({}, permit);
                                loading.isLoading = false;
                                return loading;
                            });
                            this.expiredPermits = addLoading;
                        }
                        this.loadingExpirePermit = false;
                    })
                    .catch(error => {
                        this.loadingExpirePermit = false;
                    });
            },
            expirePermit: function(item) {
                //Update
                this.editedIndex = this.expiredPermits.indexOf(item);
                item.isLoading = true;
                axios.post(this.appURL + '/api/expirepermits/' + item.permit_number, {
                    _method: 'patch',
                    uin: item.uin,
                    permit_number_series_code: item.permit_number_series_code,
                    permit_number: item.permit_number
                }).then((response) => {
                    if(response.status === 200)
                    {
                        this.expiredPermits.splice(this.editedIndex, 1);
                        this.snack = true;
                        this.snackColor = 'success';
                        this.snackText = 'Successfully Expired';
                    }
                    else {
                        this.snack = true;
                        this.snackColor = 'error';
                        this.snackText = 'Oops! Something went wrong!';
                    }
                    item.isLoading = false;
                }).catch(error => {
                    this.snack = true;
                    this.snackColor = 'error';
                    this.snackText = 'Oops! Something went wrong!';
                    item.isLoading = false;
                });
            },
        }
    }
</script>
